export default defineNuxtPlugin((nuxtApp) => {
  const { tTrim } = useLocalisation();
  return {
    provide: {
      tTrim,
    },
  };
});
